import React from 'react'

export const CarouselPrevButton = props => {
	const { className, onClick } = props

	return <div className={className} onClick={onClick} />
}

export default CarouselPrevButton
